require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-matt-wojciakowski.json") })
        }
      }, "path---blog-author-matt-wojciakowski");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-matt-wojciakowski!./.cache/json/blog-author-matt-wojciakowski.json
// module id = 675
// module chunks = 231608221292675